<template>
  <div>
    <a-card>
      <div class="text-right" style="margin-bottom: 0">
        <a-button @click="goBack">返回上一页</a-button>
      </div>
      <a-tabs
        :default-active-key="tabKey"
        @change="handleTabChange"
        :activeKey="tabKey"
      >
        <a-tab-pane :key="1" tab="企业基本信息">
          <create-form
            class="margin-bottom-30"
            ref="createForm"
            @setFieldErrors="setFieldErrors"
            @setCode="setCode"
          ></create-form>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="企业额外信息">
          <extra-info
            ref="extraInfo"
            :code="code"
            @setFieldErrors="setFieldErrors"
          ></extra-info>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <footer-tool-bar
      :fields-errors="fieldsErrors"
      @handleFieldErrorClick="handleFieldErrorClick"
    >
      <a-button class="margin-right-20" @click="reset">
        重置
      </a-button>
      <a-button type="primary" @click="handleSubmit">
        保存
      </a-button>
    </footer-tool-bar>
  </div>
</template>
<script>
import CreateForm from './components/CreateForm'
import ExtraInfo from './components/ExtraInfo'
import FooterToolBar from 'components/FooterToolBar.vue'
import { scrollToField } from 'utils/util'

export default {
  name: 'add-customer',
  data() {
    return {
      fieldsErrors: [],
      tabKey: 1,
      code: '', // 保存成功后的客户编码
    }
  },
  methods: {
    handleTabChange(key) {
      this.tabKey = key
    },
    handleFieldErrorClick({ key = '', formName = '' }) {
      switch (formName) {
        case 'formBasic':
          this.tabKey = 1
          scrollToField(`${formName}_${key}`)
          return
        case 'formExtra':
          this.tabKey = 2
          scrollToField(`${formName}_${key}`)
          return
        default:
          return
      }
    },
    setCode(code) {
      this.code = code
    },

    goBack() {
      this.$router.go(-1)
    },
    handleSubmit() {
      const tabKey = this.tabKey
      switch (tabKey) {
        case 1:
          this.$refs.createForm.handleSubmitBasic()
          return
        case 2:
          this.$refs.extraInfo.handleSubmitExtra()
          return
        default:
          return
      }
    },
    setFieldErrors(errors) {
      this.fieldsErrors = errors
    },
    reset() {
      const tabKey = this.tabKey
      switch (tabKey) {
        case 1:
          this.$refs.createForm.reset()
          break
        case 2:
          this.$refs.extraInfo.reset()
          break
        default:
          break
      }
    },
  },
  components: {
    CreateForm,
    ExtraInfo,
    FooterToolBar,
  },
}
</script>
<style lang="less" scoped>
/deep/ .margin-bottom-30 {
  margin-bottom: 30px;
}
</style>
